
import classes from "./ButtonSend.module.scss"
import { Check } from "@educaplay/core/Icons/Check";
import clsx from "clsx";

export default function ButtonSend(props) {

    const { type = "submit", onClick, disabled, className } = props;

    return (
        <button className={clsx(classes.buttonPager, classes.buttonPager__send, className)} type={type} onClick={onClick} disabled={disabled}  >
            <span className={classes.buttonPager__icon}>
                <Check/>
            </span>
        </button>
    )
}